import { Typography, List, ListItem, ListItemText, Box, Card, CardContent, Grid, Chip, Link } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function SoporteRemotoMX(){
  return (
    <>
      <SEO 
        title="Soporte Remoto México | Rolsys Solutions"
        description="Soporte técnico remoto en toda la República Mexicana. Solución rápida y segura de incidencias tecnológicas."
      />

      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Typography variant="h3" sx={{ fontWeight:800 }}>
            Soporte remoto
          </Typography>
          <Chip label="Cobertura Nacional" color="primary" />
        </Box>

        <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
          Atención técnica a distancia para todo México con herramientas seguras y eficientes
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card elevation={0} sx={{ border: '1px solid #eee', mb: 3 }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Servicios remotos disponibles
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Resolución de problemas de software"
                      secondary="Diagnóstico y solución de fallas en aplicaciones y sistemas operativos"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Configuración de sistemas"
                      secondary="Setup y configuración de software, redes y aplicaciones"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Instalación de actualizaciones"
                      secondary="Parches de seguridad, drivers y actualizaciones de software"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Capacitación de usuarios"
                      secondary="Entrenamiento virtual en el uso de herramientas y sistemas"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Monitoreo y mantenimiento"
                      secondary="Supervisión proactiva del estado de los sistemas"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>

            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Ventajas del soporte remoto
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Respuesta inmediata sin esperas por traslados" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Costos reducidos al eliminar gastos de desplazamiento" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Cobertura en toda la República Mexicana" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Conexiones seguras y encriptadas" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Disponibilidad extendida de horarios" />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Herramientas utilizadas
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Zoho Assist:</strong>{' '}
                  <Link href="https://assist.rolsyssolutions.com" target="_blank" rel="noopener noreferrer">
                    Solicitar soporte remoto
                  </Link>
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>TeamViewer:</strong>{' '}
                  <Link href="https://www.teamviewer.com/es/descarga/" target="_blank" rel="noopener noreferrer">
                    Descargar TeamViewer
                  </Link>
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>AnyDesk:</strong>{' '}
                  <Link href="https://anydesk.com/es/downloads" target="_blank" rel="noopener noreferrer">
                    Descargar AnyDesk
                  </Link>
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>RustDesk:</strong>{' '}
                  <Link href="https://rustdesk.com/es/" target="_blank" rel="noopener noreferrer">
                    Descargar RustDesk
                  </Link>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}